import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-log-detail-sidebar-item',
  templateUrl: './log-detail-sidebar-item.component.html',
  styleUrls: ['./log-detail-sidebar-item.component.scss'],
})
export class LogDetailSidebarItemComponent implements OnInit {
  @Input() log: any;

  constructor(private router: Router) { }

  ngOnInit() { }

  openRule(rulesetId: string, rulesetEventType: string) {
    const url = this.eventTypeToString(rulesetEventType);
    this.router.navigate([url.url, rulesetId]);
  }

  openLog(id: string, rulesetEventType: string) {
    this.router.navigate([`/gx/log/${rulesetEventType}/${id}`]);
  }

  eventTypeToString(eventType: string): { name: string; url: string } {
    switch (eventType) {
      case 'inquiry':
        return {
          name: 'New booking inquiry',
          url: '/gx/rule',
        };

      case 'preapproved':
        return {
          name: 'New pre-approval',
          url: '/gx/rule',
        };

      case 'pending':
        return {
          name: 'New booking request',
          url: '/gx/rule',
        };

      case 'accepted':
        return {
          name: 'New booking accepted',
          url: '/gx/rule',
        };

      case 'cancelled':
        return {
          name: 'New cancellation',
          url: '/gx/rule',
        };

      case 'timedout':
        return {
          name: 'Pre-approval expired',
          url: '/gx/rule',
        };

      case 'denied':
        return {
          name: 'Booking denied',
          url: '/gx/rule',
        };

      case 'special_offer':
        return {
          name: 'New special offer',
          url: '/gx/rule',
        };

      case 'awaiting_payment':
        return {
          name: 'Payment issues',
          url: '/gx/rule',
        };

      case 'checkin':
        return {
          name: 'Scheduled check-in',
          url: '/gx/rule',
        };

      case 'checkout':
        return {
          name: 'Scheduled check-out',
          url: '/gx/rule',
        };

      case 'review':
        return {
          name: 'Review a guest',
          url: '/gx/reviews/review',
        };

      case 'static:canned':
        return {
          name: 'New canned response',
          url: '/gx/canned-responses/resp',
        };

      default:
        return {
          name: 'New booking inquiry',
          url: '/gx/rule',
        };
    }
  }
}
